export enum TipoAutenticacao {
    TJBASEG,
    EXTERNO
}
